import { render, staticRenderFns } from "./PointSecuritymoneyComplete.vue?vue&type=template&id=67ce4355"
import script from "./PointSecuritymoneyComplete.vue?vue&type=script&lang=js"
export * from "./PointSecuritymoneyComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports